var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12a4 4 0 110-8 4 4 0 010 8zM7.333.667h1.334v2H7.333v-2zm0 12.666h1.334v2H7.333v-2zM2.343 3.286l.943-.943L4.7 3.757l-.943.943-1.414-1.413zm8.957 8.957l.943-.943 1.414 1.414-.943.943-1.414-1.414zm1.414-9.9l.943.943L12.243 4.7l-.943-.943 1.414-1.414zM3.757 11.3l.943.943-1.414 1.414-.943-.943L3.757 11.3zm11.576-3.967v1.334h-2V7.333h2zm-12.666 0v1.334h-2V7.333h2z",
    fill: "#191937"
  })));
}
export default __webpack_public_path__ + "static/svg/light-mode/sun-active.svg";
export { SvgSunActive as ReactComponent };